import {createAction, props} from "@ngrx/store";
import {ConsolidatedUserModel, FilterKeyValuePairInterface, PaginationInfoInterface, UserModel} from "../../interfaces";

export const addUser = createAction("[User] Add User", props<{user: UserModel}>());

export const addUsers = createAction("[User] Add Users", props<{users: Array<UserModel>}>());

export const updateUser = createAction("[User] Update User", props<{user: UserModel}>());

export const setUsers = createAction("[User] Set Users", props<{users: Array<UserModel>}>());

export const setPaginatedUsers = createAction("[User] Set Paginated Users", props<{users: Array<UserModel>}>());

export const setConsolidatedUsers = createAction("[User] Set Consolidated Users", props<{users: Array<ConsolidatedUserModel>}>());

export const setUsersPaginationInfo = createAction("[User] Set PaginationInfo", props<{paginationInfo: PaginationInfoInterface}>());

export const gotoUsersPage = createAction("[User] Goto Page", props<{page: number}>());

export const applyUsersFilters = createAction("[User} Apply Filter", props<{filters: Array<FilterKeyValuePairInterface>}>());

export const resetUsersFilters = createAction("[User] Reset Filters");
